import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { VaultdnsAccessService } from '../../vault-dnsaccess/vaultdns-access.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { TrnxCommonService } from 'src/app/shared/services/trnx-common.service';
import { ScrapingWebPagesService } from 'src/app/shared/services/scraping-web-pages.service';
import { validationmethod } from 'src/app/shared/models/validationmethod';

@Component({
    selector: 'app-web-scraping-popup',
    templateUrl: './web-scraping-popup.component.html',
    styleUrls: ['./web-scraping-popup.component.scss'],
    standalone: false
})
export class WebScrapingPopupComponent implements OnInit {
  formValid: FormGroup;
  formValidCheckbox: UntypedFormGroup;
  isCheckboxSelected: boolean = false;
  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  backgroundColorButton = "";
  applicationName;
  applicationUrl;
  validation_messages;
  applicationVersion;
  dnsName;
  versionList;
  caseAdded=false
  aerAdded=false
  documentAdded=false
  vaultids;
  scrapingWebPageDetails={
    dnsId:"",
    dnsName:"",
    jsonString:''
  }
  duplicateParams:any
Params={Params:{
      Case:[
            {
                ObjectId: "",
                ObjectName: null,
                Description: "",
                caseAdded:false,
                formControlIndex:0
            },
          ],
      AER:
            [{
                ObjectId: "",
                ObjectName: null,
                Description: "",
                aerAdded:false,
                formControlIndex:0
            }],
      Document:[{
                ObjectId: "",
                ObjectName: null,
                Description: "",
                documentAdded:false,
                formControlIndex:0
            }]
    }
  }
  constructor(
    private dialogref: MatDialogRef<WebScrapingPopupComponent>,
    private localStorageSettings: LocalStorageSettingsService,
    private errormessages: ErrorMessages,
    private commonService: CommonService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private trnxService: TrnxCommonService,
    private scrapingService:ScrapingWebPagesService,
    private validation: validationmethod
    ) {

      this.validation_messages = this.errormessages.webScraping;
     }

  async ngOnInit() {
    this.formValid = new FormGroup({
      dnsName: new FormControl("", [
        Validators.required,
      ]),
      caseNumber0: new FormControl("", []),
      caseName0: new FormControl({value: '', disabled: true}, []),
      caseDescription0: new FormControl({value: '', disabled: true}, []),
      aerNumber0: new FormControl("", []),
      aerName0: new FormControl({value: '', disabled: true}, []),
      aerDescription0: new FormControl({value: '', disabled: true}, []),
      documentId0: new FormControl("", []),
      documentName0: new FormControl({value: '', disabled: true}, []),
      documentDescription0: new FormControl({value: '', disabled: true}, []),
    });
    // this.formValid.addControl("caseNumber"+0,new FormControl("", []))
    // this.formValid.addControl("caseName"+0,new FormControl({value: '', disabled: true}, []))
    // this.formValid.addControl("caseDescription"+0,new FormControl({value: '', disabled: true}, []))
    this.commonService.getlookupVauleByLookUpType('Vault Version').subscribe(response => {

      console.log(response);

      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
      } else {
        this.spinner.stop();
        console.log(response);
        let res:any=response
        this.versionList= res.sort((a, b) => (a.lookupvalueid > b.lookupvalueid ? -1 : 1)); 
      }
    });
    // this.vaultids =JSON.parse(localStorage.getItem("vaultIds"));

    this.vaultids=await this.trnxService.retrieveTrnxService("vaultconfigmstr", 0);
    console.log(this.vaultids);
 
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    console.log(this.backgroundColorButton);
  }
  closeFunction() {

    //Making isCheckboxSelected to false. To close the popup.
    this.isCheckboxSelected = false;

    this.close();

  }
  close(){
    this.dialogref.close();
  }
  onVersionDropDownChange(e){
    if(this.vaultids){
      for(let i=0;i<this.vaultids.length;i++){
        if(this.vaultids[i].dnsname == e){
          console.log(this.vaultids[i].companyid);
          this.scrapingWebPageDetails.dnsId=this.vaultids[i].companyid
        }
        }
    }
      
  }
  sendDataAndClose(){
    // this.scrapingWebPageDetails.jsonString=JSON.stringify(this.Params)
    // 
    console.log(this.Params);
    // console.log(JSON.stringify(this.Params));
    
    if (!this.formValid.valid) {
      this.validation.getvalidationmessage();
      this.formValid.get("dnsName").markAsTouched();
      // this.formValid.get("applicationVersion").markAsTouched();
      for(let i=0;i<this.Params.Params.Case.length;i++){
        this.formValid.get("caseName"+i).markAsTouched();
      this.formValid.get("caseDescription"+i).markAsTouched();
      }
      for(let i=0;i<this.Params.Params.AER.length;i++){
        this.formValid.get("aerName"+i).markAsTouched();
        this.formValid.get("aerDescription"+i).markAsTouched();
      }
      for(let i=0;i<this.Params.Params.Document.length;i++){
        this.formValid.get("documentName"+i).markAsTouched();
        this.formValid.get("documentDescription"+i).markAsTouched();
      }
     
      return;
    } else {
      this.duplicateParams= JSON.parse(JSON.stringify(this.Params)); 

      // let cases = this.duplicateParams.Params.Case.filter(caseItem => caseItem.caseAdded)
      // console.log(cases);
      this.duplicateParams.Params.Case=this.duplicateParams.Params.Case.filter(caseItem => caseItem.caseAdded)
      console.log(this.duplicateParams);
      this.duplicateParams.Params.AER=this.duplicateParams.Params.AER.filter(aerItem=>aerItem.aerAdded)
      this.duplicateParams.Params.Document=this.duplicateParams.Params.Document.filter(documentItem=>documentItem.documentAdded)
      this.scrapingWebPageDetails.jsonString=JSON.stringify(this.duplicateParams)
      console.log(this.scrapingWebPageDetails);
      // this.scrapingService.insetScrapingWeb(this.scrapingWebPageDetails)
      this.scrapeTheWebPages()
    }
    this.close();
    // this.snackbar.open("Record Insertion inprogress", 'OK', {duration: 5000});
    this.snackbar.open("Content Extraction Started", "OK", { duration: 5000 });
  }
  scrapeTheWebPages(){
    // this.spinner.start();
    this.scrapingService.scrapeSelectedWebPage(this.scrapingWebPageDetails).subscribe(res=>{
      // this.spinner.stop();
      console.log(res);
      // this.getScrapingHistory()
      this.snackbar.open("Content Extraction Started", "OK", { duration: 5000 });
      // if(!res.error){
      //   this.getScrapingHistory()
      // }else{
      //   this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      // }
    })
  }
  onCaseNumberChange(object,index){
    // console.log(this.Params.Params.Case.ObjectId);
    if(this.Params.Params.Case[index].ObjectId){
      this.formValid.get("caseName"+object.formControlIndex).enable()
      this.formValid.get("caseDescription"+object.formControlIndex).enable()
      this.Params.Params.Case[index].caseAdded=true
    }else{
      this.formValid.get("caseName"+object.formControlIndex).disable()
      this.formValid.get("caseDescription"+object.formControlIndex).disable()
      this.Params.Params.Case[index].ObjectName=null;
      this.Params.Params.Case[index].Description="";
      this.Params.Params.Case[index].caseAdded=false
    }
  }
  onAERNumberChange(object,index){
    if(this.Params.Params.AER[index].ObjectId){
       this.formValid.get("aerName"+object.formControlIndex).enable()
       this.formValid.get("aerDescription"+object.formControlIndex).enable()
       this.Params.Params.AER[index].aerAdded=true
    }else{
      this.formValid.get("aerName"+object.formControlIndex).disable()
      this.formValid.get("aerDescription"+object.formControlIndex).disable()
      this.Params.Params.AER[index].ObjectName=null;
      this.Params.Params.AER[index].Description="";
      this.Params.Params.AER[index].aerAdded=false
    }
  }

  onDocumentChange(object,index){
    if(this.Params.Params.Document[index].ObjectId){
      this.formValid.get("documentName"+object.formControlIndex).enable()
      this.formValid.get("documentDescription"+object.formControlIndex).enable()
      this.Params.Params.Document[index].documentAdded=true
    }else{
      this.formValid.get("documentName"+object.formControlIndex).disable()
      this.formValid.get("documentDescription"+object.formControlIndex).disable()
      this.Params.Params.Document[index].ObjectName=null;
      this.Params.Params.Document[index].Description="";
      this.Params.Params.Document[index].documentAdded=false
    }
  }
  addCases(){
    let obj={
      ObjectId: "",
      ObjectName: null,
      Description: "",
      caseAdded:false,
      formControlIndex:this.Params.Params.Case.length
  }
    this.Params.Params.Case.push(obj)
  let casesLength=this.Params.Params.Case.length-1
  this.formValid.addControl("caseNumber"+casesLength,new FormControl("", []))
  this.formValid.addControl("caseName"+casesLength,new FormControl({value: '', disabled: true}, []))
  this.formValid.addControl("caseDescription"+casesLength,new FormControl({value: '', disabled: true}, []))
  }

  addAER(){
    console.log(this.Params.Params.AER.length);
    let obj={
      ObjectId: "",
      ObjectName: null,
      Description: "",
      aerAdded:false,
      formControlIndex:this.Params.Params.AER.length
  }
    this.Params.Params.AER.push(obj)
  let aerLength=this.Params.Params.AER.length-1
  this.formValid.addControl("aerNumber"+aerLength,new FormControl("", []))
  this.formValid.addControl("aerName"+aerLength,new FormControl({value: '', disabled: true}, []))
  this.formValid.addControl("aerDescription"+aerLength,new FormControl({value: '', disabled: true}, []))
  }

  addDocument(){
    let obj={
      ObjectId: "",
      ObjectName: null,
      Description: "",
      documentAdded:false,
      formControlIndex:this.Params.Params.Document.length
  }
    this.Params.Params.Document.push(obj)
  let documentLength=this.Params.Params.Document.length-1
  this.formValid.addControl("documentId"+documentLength,new FormControl("", []))
  this.formValid.addControl("documentName"+documentLength,new FormControl({value: '', disabled: true}, []))
  this.formValid.addControl("documentDescription"+documentLength,new FormControl({value: '', disabled: true}, []))
  }

  removeCase(object,index){
    
    this.formValid.removeControl("caseNumber"+object.formControlIndex);
    this.formValid.removeControl("caseName"+object.formControlIndex);
    this.formValid.removeControl("caseDescription"+object.formControlIndex);
    this.Params.Params.Case.splice(index,1);
    
  }
  removeAer(object,index){
    
    this.formValid.removeControl("aerNumber"+object.formControlIndex);
    this.formValid.removeControl("aerName"+object.formControlIndex);
    this.formValid.removeControl("aerDescription"+object.formControlIndex);
    this.Params.Params.AER.splice(index,1);
  }

  removeDocument(object,index){
    this.formValid.removeControl("documentId"+object.formControlIndex);
    this.formValid.removeControl("documentName"+object.formControlIndex);
    this.formValid.removeControl("documentDescription"+object.formControlIndex);
    this.Params.Params.Document.splice(index,1);
   
  }
}
